import React from "react";
import { Color } from "config/colors";
import { WorkerStatus } from "model/Tip";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { CustomIcon } from "components/icon/customIcon.component";

type Props = {
  status: WorkerStatus | null;
};

const centerStyle = {
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const WorkerStatusIndicator: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  if (props.status === null) {
    return <Text style={centerStyle}>{t("CompanyTip.NotInitiated")}</Text>;
  }

  switch (props.status) {
    case WorkerStatus.Created:
      return <Text style={centerStyle}>{t("CompanyTip.OnGoing")}</Text>;
    case WorkerStatus.Paid:
      return (
        <Text style={centerStyle}>
          {t("CompanyTip.PaidOut")}
          <CustomIcon
            name="checkmark"
            color={Color.BurntSienna}
            padding="4px"
          />
        </Text>
      );
    case WorkerStatus.Failed:
      return (
        <Text style={centerStyle}>
          {t("CompanyTip.Failed")}
          <CustomIcon name="alert" color={Color.BurntSienna} padding="4px" />
        </Text>
      );
    default:
      return <Text style={centerStyle}>{t("CompanyTip.NotInitiated")}</Text>;
  }
};
